module.exports = __webpack_public_path__ + "img/jazzy-thumbnail-fallback-soul.234c321.jpg";